(() => {
  const init = (section) => {
    if (!section || section.dataset.masarGamingReady === 'true') return;
    section.dataset.masarGamingReady = 'true';

    const options = [...section.querySelectorAll('[data-kit-option]')];
    const selectedList = section.querySelector('[data-kit-selected]');
    const subtotalNode = section.querySelector('[data-kit-subtotal]');
    const savingNode = section.querySelector('[data-kit-saving]');
    const totalNode = section.querySelector('[data-kit-total]');
    const tierNode = section.querySelector('[data-kit-tier]');
    const addButton = section.querySelector('[data-kit-add]');
    const statusNode = section.querySelector('[data-kit-status]');
    const currency = section.dataset.currency || 'EUR';
    const discountTwo = Number(section.dataset.discountTwo || 5);
    const discountThree = Number(section.dataset.discountThree || 10);
    const discountFive = Number(section.dataset.discountFive || 15);
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'it-IT', {
      style: 'currency',
      currency
    });

    const formatMoney = (cents) => formatter.format(cents / 100);
    const selectedOptions = () => options.filter((option) => option.checked && !option.disabled);

    const discountForGames = (count) => {
      if (count >= 5) return discountFive;
      if (count >= 3) return discountThree;
      if (count >= 2) return discountTwo;
      return 0;
    };

    const update = () => {
      const selected = selectedOptions();
      const games = selected.filter((option) => option.dataset.group === 'game');
      const subtotal = selected.reduce((sum, option) => sum + Number(option.dataset.price || 0), 0);
      const gamesSubtotal = games.reduce((sum, option) => sum + Number(option.dataset.price || 0), 0);
      const discount = discountForGames(games.length);
      const saving = Math.round((gamesSubtotal * discount) / 100);
      const total = subtotal - saving;

      selectedList.innerHTML = selected.length
        ? selected.map((option) => `<li><span>${escapeHtml(option.dataset.title || 'Prodotto')}</span><strong>${formatMoney(Number(option.dataset.price || 0))}</strong></li>`).join('')
        : '<li>Nessun prodotto selezionato.</li>';
      subtotalNode.textContent = formatMoney(subtotal);
      savingNode.textContent = `−${formatMoney(saving)}`;
      totalNode.textContent = formatMoney(total);
      addButton.disabled = selected.length === 0;

      if (games.length === 0) tierNode.textContent = 'Seleziona 2 giochi per ottenere il primo sconto bundle.';
      else if (games.length === 1) tierNode.textContent = 'Aggiungi ancora 1 gioco per ottenere lo sconto bundle.';
      else if (games.length === 2) tierNode.textContent = `Sconto ${discountTwo}% raggiunto. Con 3 giochi passa al ${discountThree}%.`;
      else if (games.length < 5) tierNode.textContent = `Sconto ${discountThree}% raggiunto. Con 5 giochi passa al ${discountFive}%.`;
      else tierNode.textContent = `Sconto massimo del ${discountFive}% sui giochi raggiunto.`;
    };

    const escapeHtml = (value) => String(value).replace(/[&<>'"]/g, (char) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#039;', '"': '&quot;'
    })[char]);

    options.forEach((option) => {
      option.addEventListener('change', () => {
        if (option.checked && option.dataset.exclusive) {
          options.forEach((candidate) => {
            if (candidate !== option && candidate.dataset.exclusive === option.dataset.exclusive) candidate.checked = false;
          });
        }
        statusNode.textContent = '';
        update();
      });
    });

    addButton?.addEventListener('click', async () => {
      const selected = selectedOptions();
      if (!selected.length) return;

      addButton.disabled = true;
      addButton.setAttribute('aria-busy', 'true');
      statusNode.textContent = 'Sto preparando il tuo kit…';

      const items = selected.map((option) => ({
        id: Number(option.dataset.variantId),
        quantity: 1,
        properties: { _masar_kit: 'gaming' }
      }));

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'Non è stato possibile aggiungere tutti i prodotti.');
        }
        statusNode.textContent = 'Kit aggiunto. Apro il carrello…';
        window.location.assign(`${root}cart`);
      } catch (error) {
        statusNode.textContent = error.message || 'Si è verificato un errore. Riprova tra poco.';
        addButton.disabled = false;
        addButton.removeAttribute('aria-busy');
      }
    });

    update();
  };

  const initAll = (root = document) => root.querySelectorAll('[data-masar-gaming]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
